/** Sustainability issue codes mapped to Norwegian names. */
export const sustainabilityIssuesNb: Record<string, string> = {
  climateChange: "Klimaendringer",
  pollution: "Forurensning",
  waterMarine: "Vann og marine ressurser",
  biodiversity: "Biologisk mangfold og økosystemer",
  circularEconomy: "Sirkulær økonomi",
  ownWorkforce: "Egen arbeidsstyrke",
  workersValueChain: "Arbeidere i verdikjeden",
  affectedCommunities: "Berørte lokalsamfunn",
  consumersEndUsers: "Forbrukere og sluttbrukere",
  businessConduct: "Forretningsatferd",
}

/** Array of { code, name } for use in dropdowns. Order follows the VSME standard. */
export const sustainabilityIssuesOptionsNb: Array<{ code: string; name: string }> = Object.entries(
  sustainabilityIssuesNb,
).map(([code, name]) => ({ code, name }))
